import { inject, Injectable } from '@angular/core'
import { Translation, TranslocoLoader } from '@jsverse/transloco'
import { HttpClient } from '@angular/common/http'
import { catchError, forkJoin, map, of } from 'rxjs'
import { tenant } from '@env/tenant'

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient)

  getTranslation(lang: string) {
    return forkJoin({
      base: this.http.get<Translation>(`/assets/i18n/${lang}.json`),
      override: this.http
        .get<Translation>(`/assets/i18n/${tenant}/${lang}.json`)
        .pipe(catchError(() => of({} as Translation))),
    }).pipe(map(({ base, override }) => mergeTranslations(base, override)))
  }
}

// Fusion profonde : une surcharge de tenant ne redefinit que les cles qu'elle
// contient, sans ecraser le reste de la section (ex. ORDER_TYPE.SIGNALLER seul).
export function mergeTranslations(base: Translation, override: Translation): Translation {
  const merged: Translation = { ...base }
  for (const [key, value] of Object.entries(override)) {
    const current = merged[key]
    const bothObjects =
      value && typeof value === 'object' && !Array.isArray(value) && current && typeof current === 'object'
    merged[key] = bothObjects ? mergeTranslations(current, value) : value
  }
  return merged
}
